<template>
  <div class="selected-items-block">
    <div class="selected-items-block__summary">
      {{ totalItemsText }}
    </div>
    <div
      v-if="!disabled"
      class="selected-items-block__reset"
    >
      <SelectedItemsBlockReset
        @reset="$emit('input', [])"
      />
    </div>
    <div class="selected-items-block__list">
      <div
        v-for="(chunk, chunkId) in chunkedChoices"
        :key="chunkId"
        v-observe-visibility="getObserverConfig(chunkId)"
        class="m-lazy-render__chunk m-lazy-render__lazy-enabled"
        :style="getCssVarsForChunk(chunkId)"
      >
        <template v-if="!chunkIsVisible(chunkId)">
          <div class="m-lazy-render__lazy-dummy-node" />
        </template>
        <template v-else>
          <SelectedItem
            v-for="item in chunk"
            :key="item.id"
            :item="item"
            :disabled="disabled"
            class="selected-items-block-list__item"
            @removeItem="handleRemoveItem(item)"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
  import getTr from 'translation';
  import SelectedItemsBlockReset from 'components/Inputs/Select/common/SelectedItemsBlock/SelectedItemsBlockReset';
  import _ from 'lodash';
  import SelectedItem from 'components/Inputs/Select/common/SelectedItemsBlock/SelectedItem';
  import LazyRenderMixin from 'components/mixins/LazyRenderMixin';
  _.noConflict();

  const CHECKBOX_ITEM_HEIGHT = 28;

  export default {
    name: 'SelectedItemsBlock',
    components: {SelectedItem, SelectedItemsBlockReset},
    mixins: [LazyRenderMixin],
    props: {
      value: {
        type: Array,
        required: true
      },
      itemsFlat: {
        type: Array,
        required: true
      },
      disabled: {
        type: Boolean,
        default: false
      },
      formatSelectedCounterText: {
        type: Function,
        default: null
      }
    },
    computed: {
      singleElementHeight () {
        return CHECKBOX_ITEM_HEIGHT;
      },
      choices () {
        return this.selectedItems;
      },
      totalItemsText () {
        if (this.formatSelectedCounterText) {
          return this.formatSelectedCounterText(this.value, this.itemsFlat);
        }
        return getTr('items_chosen_format').format(this.value.length);
      },
      flatItemsMap () {
        return _.keyBy(this.itemsFlat, 'id');
      },
      selectedItems () {
        return this.value.map(i => this.flatItemsMap[i]).filter(i => Boolean(i));
      }
    },
    methods: {
      handleRemoveItem (item) {
        this.$emit(
          'input',
          this.value.filter(i => i !== item.id)
        );
      }
    }
  };
</script>

<style>
  .selected-items-block__summary {
    font-size: 14px;
    font-weight: var(--medium-font-weight);

    color: var(--secondary-text-color);
  }

  .selected-items-block__reset {
    padding-top: 12px;
  }

  .selected-items-block__list {
    overflow-y: auto;
    margin-top: 2px;
  }

  .selected-items-block-list__item {
    margin-top: 6px;
  }
</style>
